import { animateScroll as scroll } from "react-scroll";
import { isString } from "./Types/typeUtilities";

export const emptyGuid = "00000000-0000-0000-0000-000000000000";

export function isGuidEmpty(guid: string | null | undefined): boolean {
	return !guid || guid === emptyGuid;
}

export function isTrimmedStringEmpty(value: unknown): boolean {
	return !isString(value) || value.trim().length === 0;
}

export function isNullOrUndefined(value: unknown): value is null | undefined {
	return value === null || value === undefined;
}

export function createRedirectUrl(pathName: string, searchString?: string): string {
	return searchString ? pathName + searchString : pathName;
}

export function convertCamelCaseToSpaceDelimited(string = "", makeProperCase = false): string {
	if(isTrimmedStringEmpty(string))
		return "";

	if (makeProperCase) {
		string = string.charAt(0).toUpperCase() + string.substring(1);
    }

	const regex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
	return string.replace(regex, "$1$4 $2$3$5");
}

export function convertUnderscoreToDash(string: string): string {
	let result = string.replace(/__/gi, "- ");
	return result.replace(/_/gi, "-");
}

export function convertToNumber(value: unknown = "not a number"): number | undefined {
	let trimmedValue = value;
	if(isString(trimmedValue))
		trimmedValue = trimmedValue.trim();

	const conversion = Number(trimmedValue);
	return isNaN(conversion) ? undefined : conversion;
}

export function convertToBoolean(value: unknown = "not a bool"): boolean {
	if(isNullOrUndefined(value))
		return false;

	return String(value).toLowerCase().trim() === "true";
}

export function createKey(): string {
    return crypto.randomUUID();
}

export const scrollToTop = (): void => {
    scroll.scrollToTop({
        duration: 0,
        smooth: "easeOutQuint",
    });
};

export function getSiteProtocolDomain(): string {
	return `${document.location.origin}/#`;
}


export function numberOfDecimalPlaces(number: string | number = ""): number {
	const b = String(number).split(".");
	return b[1] ? b[1].length : 0;
}

export function validateDecimal(value: number = 0, digits = 2): string {
	if (!value) return (0).toFixed(digits);
	const converted = convertToNumber(`${value}`);
	return converted !== undefined ? converted.toFixed(digits) : (0).toFixed(digits);
}

export function truncateString (value: string, maxLength=30): string  {
if (!value) return "";
if (value.length <= maxLength) {
return value;
}

return value.substring(0, maxLength) + '...';
}